import { render, staticRenderFns } from "./UserQualificationsTable.vue?vue&type=template&id=9bcd19f6"
import script from "./UserQualificationsTable.vue?vue&type=script&lang=js"
export * from "./UserQualificationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports